/** Raíz de las rutas del Portal Condominio. */
export const RUTA_PORTAL_CONDOMINIO = "/admin/portal-condominio";

/** Detalle de una unidad por su cuenta de mantenimiento: la 419 tiene dos y el número no basta. */
export const rutaUnidadCondominio = (idCuenta: number): string =>
  `${RUTA_PORTAL_CONDOMINIO}/departamentos/${idCuenta}`;

/** Amenidades (#1522): raíz de sus pestañas, detalle de una reserva (por folio) y de una amenidad. */
export const RUTA_AMENIDADES = `${RUTA_PORTAL_CONDOMINIO}/amenidades`;
export const rutaReservaAmenidad = (folio: string): string => `${RUTA_AMENIDADES}/reservaciones/${encodeURIComponent(folio)}`;
export const rutaAmenidad = (id: number | "nueva"): string => `${RUTA_AMENIDADES}/catalogo/${id}`;
/** Ticket del Portal Condominio por folio (`?ticket=` lo abre en Tickets). */
export const rutaTicketCondominio = (folio: number): string => `${RUTA_PORTAL_CONDOMINIO}/tickets?ticket=${folio}`;
